import {
    ClientDetailModel,
    ClientProfileDetailModel,
    ClientProfileType,
} from 'lemunzo-api';

export function getClientProfileType(
    clientDetail: ClientProfileDetailModel | ClientDetailModel | null
): ClientProfileType {
    return clientDetail?.person
        ? ClientProfileType.Person
        : ClientProfileType.Organization;
}
